export default __webpack_public_path__ + "static/media/DOCTORCERTIFICATEFOR5DISEASES_EN.20d5e0b7.png";